"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var TTL = {
    TEN_MINUTES: 60 * 10 * 1000,
    HOUR: 60 * 60 * 1000,
    TEN_HOURS: 10 * 60 * 60 * 1000,
    DAY: 24 * 60 * 60 * 1000,
    TWO_DAYS: 48 * 60 * 60 * 1000,
    WEEK: 7 * 24 * 60 * 60 * 1000
};
function shouldUpdate(data, cacheTTL) {
    if (!data)
        return true;
    var updateTime;
    if (lodash_1["default"].isNumber(data) || lodash_1["default"].isDate(data)) {
        updateTime = moment_1["default"](data);
    }
    else {
        if (!data.storeUpdatedAt)
            return true;
        updateTime = moment_1["default"](data.storeUpdatedAt);
    }
    var diff = moment_1["default"].now() - updateTime;
    return diff > cacheTTL;
}
exports["default"] = {
    TTL: TTL,
    shouldUpdate: shouldUpdate
};
